import TrackableRedirect from '@components/TrackingRedirect';

const Spotify = () => {
  return <TrackableRedirect to="/ai-team-rating" />;
};

export default Spotify;
